const isPlainObject = (value: object): value is Record<string, unknown> =>
    typeof value !== 'function' &&
    Object.getPrototypeOf(value) === Object.prototype &&
    Object.keys(value).length > 0;

const isErrorLike = (value: object): value is Error =>
    value instanceof Error ||
    (typeof DOMException !== 'undefined' && value instanceof DOMException);

export const parseError = (error: unknown): string | Record<string, unknown> => {
    if (error === undefined || error === null) {
        return 'The error caught is null or undefined from try/catch statement.';
    }

    if (typeof error === 'string' || typeof error === 'number') return String(error);

    if (typeof error === 'object') {
        if (isPlainObject(error)) return error;

        if (typeof Response !== 'undefined' && error instanceof Response) {
            return {
                name: 'Response',
                status: error.status,
                statusText: error.statusText,
                url: error.url,
            };
        }

        try {
            /**
             * Stringify the object (i.e., Class) and attempt to convert it back to a readable object.
             * Classes cannot be logged using JSON.stringify() directly.
             */
            const stringifiedError = JSON.stringify(error, Object.getOwnPropertyNames(error));
            const ownProperties = JSON.parse(stringifiedError);

            if (isErrorLike(error)) {
                return { ...ownProperties, name: error.name, message: error.message };
            }

            return ownProperties;
        } catch (error) {
            return `An error occurred when parsing error: ${error}.`;
        }
    }

    return `The error is not parseable: ${error}`;
};
